/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Priority_SupportInputs */

const en_landing_pricing_feature_priority_support = /** @type {(inputs: Landing_Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority support`)
};

const zh_landing_pricing_feature_priority_support = /** @type {(inputs: Landing_Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先支持`)
};

/**
* | output |
* | --- |
* | "Priority support" |
*
* @param {Landing_Pricing_Feature_Priority_SupportInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_priority_support = /** @type {((inputs?: Landing_Pricing_Feature_Priority_SupportInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Priority_SupportInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_priority_support(inputs)
	return zh_landing_pricing_feature_priority_support(inputs)
});
export { landing_pricing_feature_priority_support as "landing.pricing.feature_priority_support" }